export default __webpack_public_path__ + "static/media/delete-icon.4663c0b5.jpeg";